import { Component, OnInit, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UserApiService } from 'shared/services';

@Component({
    selector: 'app-dal-redirect',
    imports: [TranslateModule],
    templateUrl: './dal-redirect.component.html',
    styleUrl: './dal-redirect.component.scss',
})
export class DalRedirectComponent implements OnInit {
    isRedirectError = signal(false);

    constructor(private userApiService: UserApiService) {}

    ngOnInit(): void {
        this.userApiService.redirectToDal().subscribe({
            next: (response) => {
                if (response?.dalRedirectUrl) {
                    this.isRedirectError.set(false);
                    window.location.href = response.dalRedirectUrl;
                } else {
                    this.isRedirectError.set(true);
                }
            },
            error: () => {
                this.isRedirectError.set(true);
            },
        });
    }
}
